import { LoadingDialog } from '@/components/controls';
import { useDeletePrisoner, usePrisoner, useUpsertPrisoner } from '@/hooks';
import { PrisonerEditorDialog } from './PrisonerEditorDialog';

export function PrisonerEditor({ code, isOpen, onClose, groupCodes }) {
  const { data: prisoner } = usePrisoner(code, {
    name: '',
    custodyNumber: '',
    occurrenceCode: '',
    offence: '',
    arrestingOfficerCode: '',
    investigatingOfficerCode: '',
    officerInCaseCode: '',
    arrivalTime: '',
    custodyUnit: '',
    observationLevel: '',
  });
  const { mutate: upsertPrisoner } = useUpsertPrisoner();
  const { mutate: deletePrisoner } = useDeletePrisoner();

  function handleClose(values) {
    if (values) {
      upsertPrisoner(values);
    }

    onClose();
  }

  function handleDelete() {
    deletePrisoner(code);

    onClose();
  }

  return prisoner ? (
    <PrisonerEditorDialog
      prisoner={prisoner}
      isOpen={isOpen}
      onClose={handleClose}
      onDelete={handleDelete}
      groupCodes={groupCodes}
    />
  ) : (
    <LoadingDialog isOpen={isOpen} />
  );
}
